import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from '@cx-shared/components/layout/layout.component';
import { PageNotFoundComponent } from '@cx-shared/components/page-not-found/page-not-found.component';
import {MaintenanceComponent} from "@cx-shared/components/maintenance/maintenance.component";

const routes: Routes = [
  {
    path: '',
    canActivate: [],
    loadChildren: () => import('./cx-modules/cx-modules.module').then((m) => m.CxModulesModule),
  },
  {
    path: 'booking',
    canActivate: [],
    loadChildren: () => import('./cx-booking-modules/cx-booking-modules.module').then((m) => m.CxBookingModulesModule),
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  { path: '404', component: PageNotFoundComponent },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
